import { Component, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import {
  MatTableDataSource,
  MatDialog,
  MatPaginator,
  MatSelectChange
} from "@angular/material";

import { SoundEnum } from "src/app/enums/sound.enum";
import { ICourseType } from "src/app/interfaces/course-type";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { CourseTypeEntryComponent } from "./../course-type-entry/course-type-entry.component";
import { CourseTypeService } from "src/app/services/http/business/course-type/course-type.service";
import { IConfirm } from "src/app/interfaces/confirm";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { ICompany } from "src/app/interfaces/company";
import { ErrorsService } from "src/app/services/common/errors.service";
import { CIDService } from "src/app/services/common/cid.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { BIDService } from "src/app/services/common/bid.service";

@Component({
  selector: "app-course-type-list",
  templateUrl: "./course-type-list.component.html",
  styleUrls: ["./course-type-list.component.css"]
})
export class CourseTypeListComponent implements OnInit {
  isOwner: boolean;
  companyCode: string;
  companyList: ICompany;
  companySelected: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  dataSource = new MatTableDataSource<ICourseType>();
  displayedColumns: string[] = [this.translate.get("label.title"), "state", "function"];
  pageSize: number;
  pageIndex: number;

  constructor(
    private dialog: MatDialog,
    private cidService: CIDService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private bidService: BIDService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private snackbarService: SnackBarService,
    private courseTypeService: CourseTypeService
  ) { }

  ngOnInit() {
    this.checkOwner();
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 10;
  }

  checkOwner() {
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
        this.refresh();
      }
      else {
        this.refresh();
      }
    });
  }

  refresh() {
    if (this.isOwner)
      this.bidService.removeBID();
    this.courseTypeService.list(this.paginator.pageIndex + 1, this.paginator.pageSize).subscribe(res => {
      this.companySelected = this.cidService.getCID();
      this.dataSource = res.DataList;
      this.paginator.length = res.Total;

    });
  }

  add() {
    this.dialog
      .open(CourseTypeEntryComponent, {
        width: "500px",
        data: null
      })
      .afterClosed()
      .subscribe(
        () => {
          this.courseTypeService.list().subscribe(re => {
            this.paginator.pageIndex = 0;
            this.dataSource = re.DataList;
            this.paginator.length = re.Total;
            this.companySelected = this.cidService.getCID();
          });
        },
        () => {
          this.snackbarService.OpenSnackBar(
            this.translate.get("error.transaction"),
            "ok",
            5000,
            SoundEnum.beep
          );
        }
      );
  }

  edit(id: number) {
    this.courseTypeService.getById(id).subscribe(res => {
      this.dialog
        .open(CourseTypeEntryComponent, {
          width: "500px",
          data: res
        })
        .afterClosed()
        .subscribe(
          () => {
            this.refresh();
          },
          () => {
            this.snackbarService.OpenSnackBar(
              this.translate.get("error.transaction"),
              "ok",
              5000,
              SoundEnum.beep
            );
          }
        );
    });
  }

  toggleState(data: ICourseType) {
    let confirm: IConfirm;
    if (data.Active) {
      confirm = {
        accept: true,
        message: this.translate.get("confirm.inActive", {
          name: this.translate.get("label.courseType") + ": " + data.Title
        }),
        alert: null,
        yesLabel: this.translate.get("label.yes"),
        noLabel: this.translate.get("label.no")
      };
    }
    else {
      confirm = {
        accept: true,
        message: this.translate.get("confirm.active", {
          name: this.translate.get("label.courseType") + ": " + data.Title
        }),
        alert: null,
        yesLabel: this.translate.get("label.yes"),
        noLabel: this.translate.get("label.no")
      };
    }


    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "350px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.courseTypeService.courseTypeToggleState(data).subscribe(
          () => {
            this.snackbarService.OpenSnackBar(
              'تغییر وضعیت با موفقیت انجام شد',
              "ok",
              5000,
              SoundEnum.beep
            );
            this.refresh();
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  delete(data: ICourseType): void {
    let confirm: IConfirm = {
      accept: true,
      message: this.translate.get("confirm.delete", {
        name: this.translate.get("label.courseType") + " " + data.Title
      }),
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        var command = {Id: data.Id}
        this.courseTypeService.delete(command).subscribe(
          () => {
            this.refresh();
          },
          err => {
            this.errorService.recordHasBennUsed(err);
          }
        );
      }
    });
  }

  paginatorEvent(event) {
    this.courseTypeService
      .list(event.pageIndex + 1, event.pageSize)
      .subscribe(res => {
        this.paginator.pageIndex = event.pageIndex;
        this.paginator.pageSize = event.pageSize;
        this.dataSource = new MatTableDataSource(res.DataList);
        this.paginator.length = res.Total;
      });
  }

  courseTypeList(e: MatSelectChange) {
    this.companyCode = e.value;
    let _this = this;
    this.cidService.setCID(e.value);
    setTimeout(function () {
      _this.refresh();
    }, 500)

  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(
      res => {
        this.companyList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  // ngOnDestroy() {
  //   if (this.isOwner) this.cidService.setCID("");
  // }
}
